import { Skeleton } from "@/components/ui/skeleton";
import { useAudio } from "@/app/providers/audio-provider";
import { Suspense, useState, useEffect } from "react";
import { Link, Outlet } from "react-router";

const Fallback = () => (
	<div className="grid min-h-svh lg:grid-cols-2">
		<div className="relative hidden bg-muted lg:block">
			<img
				src="/abstract/abstract_8.png"
				alt="Login background"
				className="absolute inset-0 h-full w-full object-cover dark:brightness-[0.2] dark:grayscale"
			/>
		</div>
		<div className="h-svh overflow-y-scroll flex flex-col gap-4 p-6 md:p-10">
			<div className="flex justify-center gap-2">
				<Link
					to="/"
					className="flex items-center gap-2 font-[Lora] text-lg font-medium"
				>
					<img
						className="h10 w-10 rounded-l"
						src="/logos/icon.png"
						alt="Logo"
					/>
					coffitivity
				</Link>
			</div>
			<div className="flex flex-1 items-center justify-center">
				<div className="w-full max-w-sm dark:border bg-background rounded-lg p-4 py-6">
					<Outlet />
				</div>
			</div>
		</div>
		<div className="flex flex-1 items-center justify-center">
			<div className="w-full max-w-xs space-y-2">
				<Skeleton className="h-4 w-3/4 m-auto" />
				<Skeleton className="h-[150px] w-full" />
			</div>
		</div>
	</div>
);

const AuthLayout = () => {
	const testimonials: string[] = [
		"If, like me, you are productive in coffee shops and miss working in them, bring the coffee shop noise to you! Thanks @coffitivity",
		"I had great success with it, try out Coffitivity. It gets me in the zone each time!",
		"Noise is such an important part of my workflow as well. Coffitivity's Morning Murmur coffee shop sounds always gets me in the zone.",
		"I don't know who showed me @coffitivity and coffee shop white noise but holy frick it is helpful, thank you.",
		"For anyone that misses the background noise of your favorite coffee shop when trying to work, this @coffitivity thing is pretty good",
	];

	const [randomQuote, setRandomQuote] = useState("");

	useEffect(() => {
		const quote = testimonials[Math.floor(Math.random() * testimonials.length)];
		setRandomQuote(quote);
	}, []);

	const { handlePause } = useAudio();
	handlePause();

	return (
		<Suspense fallback={<Fallback />}>
			<div className="grid min-h-svh lg:grid-cols-2">
				{/* Auth Quote */}
				<div className="relative hidden bg-brand lg:flex lg:items-center lg:justify-center lg:p-12">
					<div className="max-w-2xl mx-auto text-center space-y-6">
						<svg
							className="w-12 h-12 mx-auto text-brand-foreground/30"
							fill="currentColor"
							viewBox="0 0 24 24"
						>
							<title>Quote Symbol</title>
							<path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
						</svg>
						<blockquote className="text-xl md:text-2xl font-[Lora] font-medium text-brand-foreground leading-relaxed italic">
							{randomQuote}
						</blockquote>
						<div className="w-16 h-1 mx-auto bg-brand-foreground/20 rounded-full" />
					</div>
				</div>
				{/* Auth Form */}
				<div className="h-svh overflow-y-scroll flex flex-col gap-4 p-6 md:p-10">
					<div className="flex justify-center gap-2">
						<Link
							to="/"
							className="flex items-center gap-2 font-[Lora] text-lg font-medium"
						>
							<img
								className="h10 w-10 rounded-l"
								src="/logos/icon.png"
								alt="Logo"
							/>
							coffitivity
						</Link>
					</div>
					<div className="flex flex-1 items-center justify-center">
						<div className="w-full max-w-sm dark:border bg-background rounded-lg p-4 py-6">
							<Outlet />
						</div>
					</div>
				</div>
			</div>
		</Suspense>
	);
};

export default AuthLayout;
